import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";
import {DashboardTab} from "../models/DashboardTab";

interface DashboardTabCollectionOptions {
    dashboardId: number
}

export class DashboardTabCollection extends CachingCollection<DashboardTab> {
    urlRoot = '/api/v1/dashboards/';
    dashboardId: number;

    url = () => {
        return this.urlRoot + this.dashboardId + '/tabs';
    };

    constructor(initialModels: Object[] | any[], options: DashboardTabCollectionOptions) {
        super(initialModels, options);
        this.dashboardId = options.dashboardId;
    }

    comparator = (model) => {
        return model.get('order');
    }
}




// WEBPACK FOOTER //
// ./srv/public/js/collections/DashboardTabs.ts